module.exports = __webpack_public_path__ + "img/Stacy Lee George.64946d91.jpg";